
import { useEffect, useState } from "react"
import url from "../api/url"
import { elToast } from "../functions/Alerta"
import { useEmpleadoStore } from "../stores/useEmpleadoStore"

const useRegistroNombre = () => {

    // variables
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const nombreInicial = {
        funcion: 'editarNombre',
        nombre: '',
        apellido: '',
        correo: objLogueado.email
    }
    const { URL } = url()
    const [formNombres, setFormNombres] = useState( nombreInicial )
    const [cargando, setCargando] = useState( false )



    // funciones
    const editarNombre = () => {

        setCargando( true )

        fetch( URL, {
            method: 'post',
            body: JSON.stringify( formNombres )
        })
        .then( res => res.json() )
        .then( d => {
            if ( d.codigo === 1 ) {
                elToast( d.mensaje )
            } else if ( d.codigo === 0 ) {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast( 'Hay problemas al guardar la información', 'error' )
        })
        .finally( () => setCargando( false ) )
    }

    const traerNombres = () => {

        var fd = new FormData()
        fd.append("funcion", "traerNombres")
        fd.append("correo", objLogueado.email)

        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.json() )
        .then( e => {
            setFormNombres({ ...formNombres, nombre: e.nombre, apellido: e.apellido })
        })
        .catch( a => {
            elToast( 'Hay problemas al traer la información', 'error' )
        })
    }

    useEffect(() => {
        traerNombres();
        //eslint-disable-next-line
    }, [])



    return {
        editarNombre, cargando, formNombres, setFormNombres
    }
}

export default useRegistroNombre
